export const CEditAbsenceTime: any = {
    confirmed: "",
    fromDate: "",
    fromDateGermanStyle: "",
    fromTime: "",
    hashedName: "",
    id: "",
    isActive: "",
    realName: "",
    reason: "",
    reasonComment: "",
    reasonForAbsence_id: "",
    tillDate: "",
    tillDateGermanStyle: "",
    tillTime: "",
    uploadFile_id: "",
};